module.exports = __webpack_public_path__ + "img/calendarUploadIcon.2550894b.svg";